/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { View } from 'react-native-web';
import { connect } from 'react-redux';

import { Col, Container, Row } from 'reactstrap';

import { css } from '@emotion/react';

import Colors from 'Themes/colors';

import LoadingModal from 'Components/LoadingModal';
import ErrorMessage from 'Components/Common/ErrorMessage';
import PageSkeleton from 'Components/Skeletons/PageSkeleton';

import Actions from 'Redux/Actions';
import Selectors from 'Redux/Selectors';

import FeaturedProduct from 'Containers/Home/Components/FeaturedProduct';
import GoldPriceChangeAlert from './Components/GoldPriceChangeAlert';
import EditableProductList from './Components/EditableProductList';
import CartOrderSummary from './Components/CartOrderSummary';
import ModalUnavailableProducts from './Components/ModalUnavailableProducts';
import {
    cartContainer,
    cartTitle,
    outOfStockText,
} from './Styles/CartStyles';

const Cart = (props) => {
    const {
        cartItems,
        cartLoading,
        updateCartQuantityLoading,
        stockUnavailableVisible,
        dismissStockUnavailable,
        getCart,
        productList,
    } = props;

    useEffect(() => {
        if (!cartLoading && !cartItems.length) getCart();

        return () => {
            dismissStockUnavailable();
        };
    }, []);

    const renderCart = () => {
        const { cartError } = props;

        if (cartLoading) return <PageSkeleton />;
        if (cartError) {
            return (
                <div style={{ marginTop: 20 }}>
                    <ErrorMessage error={cartError} />
                </div>
            );
        }

        return (
            <div>
                <GoldPriceChangeAlert />

                {stockUnavailableVisible && (
                    <div css={outOfStockText}>
                        Some items are out of stock. They have been removed from your cart.
                    </div>
                )}

                {/* <ErrorMessage
                    error={updateCartQuantityError}
                    style={{ marginTop: 30, marginBottom: -10 }}
                    textStyle={{ textAlign: 'left' }}
                /> */}

                <EditableProductList products={cartItems} />
            </div>
        );
    };

    return (
        <View>
            <Container fluid css={cartContainer}>
                {/* <CartBreadcrumbs currentItem={0} /> */}
                <Row>
                    <Col xs={12} xl={8}>
                        <Row>
                            <Col xs={8} md={10}>
                                <div css={cartTitle}>My Cart</div>
                            </Col>
                            {/* <Col xs={4} md={2} css={{ textAlign: 'end' }}>
                                <div css={cartItems}>
                                    {`${cartItems.length} Items`}
                                </div>
                            </Col> */}
                        </Row>

                        {renderCart()}
                    </Col>
                    <Col xs={12} xl={4}>
                        <CartOrderSummary />
                    </Col>
                </Row>

                <Container fluid css={styles.container}>
                    <div css={styles.title}>You may also like</div>
                    <Row xs={1} sm={4} md={5} style={{ marginTop: 20 }}>
                        {
                            productList.slice(0, 4).map((product) => (

                                <Col xs={6} sm={4} md={3} key={product.id} css={styles.featured}>
                                    <FeaturedProduct product={product} type='list' />
                                </Col>

                            ))
                        }
                    </Row>
                </Container>
            </Container>

            <ModalUnavailableProducts isOpen={stockUnavailableVisible} />
            <LoadingModal loading={updateCartQuantityLoading} text='Updating..' />
        </View>
    );
};

const mapStateToProps = (state) => ({
    cartLoading: Selectors.getCartCartAttempting(state),
    cartError: Selectors.getCartCartError(state),
    cartId: Selectors.getCartId(state),
    cartItems: Selectors.getCartItems(state),
    updateCartQuantityLoading: Selectors.getCartUpdateQuantityAttempting(state),
    updateCartQuantityError: Selectors.getCartUpdateQuantityError(state),
    stockUnavailableVisible: Selectors.getUiCartStockUnavailableVisible(state),
    productList: Selectors.getProductsList(state),
});

const mapDispatchToProps = (dispatch) => ({
    dismissStockUnavailable: () => dispatch(Actions.uiSetCartStockUnavailable(false)),
    getCart: () => dispatch(Actions.cartGetCart()),
});

const styles = {
    container: css({
        margin: 0,
        padding: 0,

        '@media(min-width:300px)': {
            paddingTop: 50,
            paddingBottom: 20,
            backgroundColor: Colors.white,
            border: '1px',
            borderWidth: 1,
            borderColor: Colors.border,
            textAlign: 'center',
            marginTop: 10,
        },

        '@media(min-width:1200px)': {
            paddingTop: 100,
            paddingBottom: 20,
            backgroundColor: Colors.white,
            border: '1px',
            borderWidth: 1,
            borderColor: Colors.border,
            textAlign: 'center',
            marginTop: 10,
        },
    }),
    title: css({
        fontFamily: 'Playfair',
        fontSize: '3rem',
        color: 'black',
        textAlign: 'start',
        fontWeight: 'bold',
        letterSpacing: 1,
        transform: 'scale(1, 0.9)',
    }),

    featured: css({
        '@media(min-width:300px)': {
            padding: 0,
        },

        '@media(min-width:1200px)': {
            padding: 40,
        },
    }),
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
